export let getListConversations;
export let listJoined;

export function setChannel(channel) {
    getListConversations = channel.getListConversations;
    listJoined = channel.listJoined;
}
